import { Grid } from '@chakra-ui/react';
import Card from './Card';

const PostGrid = ({ filteredPosts }) => {
  const renderPosts = () => {
    return filteredPosts.map((post) => <Card key={post.id} post={post} />);
  };

  return (
    <Grid id="post-grid" templateColumns={['1fr', '1fr', 'repeat(2, 1fr)']} gap={'36px'} pt={4}>
      {renderPosts()}
    </Grid>
  );
};

export default PostGrid;
